import React, { createContext, useContext } from 'react'

const EventHubContext = createContext({
    eventIdentifier: undefined,
    competition: undefined,
    presentation: undefined,
    canEdit: false,
    isLoading: false,
    // Organizer (canEdit) mode only — settings components mutate the shared
    // hub state after a successful save.
    setCompetition: () => {},
    setPresentation: () => {},
    setIsLoading: () => {},
})

export default function EventHubProvider({ value, children }) {
    return <EventHubContext.Provider value={value}>{children}</EventHubContext.Provider>
}

export const useEventHub = () => useContext(EventHubContext)
